import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCertificatesList,
  receivedOffersDetail,
  sellerService,
} from "./sellerService";
import { data } from "react-router-dom";

//Get all products
export const fetchAllProducts = createAsyncThunk(
  "seller/fetchAllProducts",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getAllProducts();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch products",
      );
    }
  },
);

//Get product details
export const fetchProductDetails = createAsyncThunk(
  "seller/fetchProductDetails",
  async (id, thunkAPI) => {
    try {
      const response = await sellerService.getProductDetail(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch product details",
      );
    }
  },
);

//update product
export const updateProduct = createAsyncThunk(
  "seller/updateProduct",
  async ({ id, data }, thunkAPI) => {
    console.log("update data:", data);
    try {
      const response = await sellerService.updateProduct(id, data);
      console.log("update response:", response);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update product",
      );
    }
  },
);

//create product
export const createProduct = createAsyncThunk(
  "seller/createProduct",
  async (data, thunkAPI) => {
    try {
      console.log("Crete Data in thunk:", data);
      const response = await sellerService.createProduct(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message:
          error?.response?.data?.message ||
          error?.data?.message ||
          "Failed to create product",
        errors: error?.response?.data?.errors || error?.data?.errors || null,
        status: error?.response?.status || 500,
      });
    }
  },
);

//delete product
export const deleteProduct = createAsyncThunk(
  "seller/deleteProduct",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await sellerService.deleteProduct(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message:
          error?.response?.data?.message ||
          error?.data?.message ||
          "Failed to create product",
        errors: error?.response?.data?.errors || error?.data?.errors || null,
        status: error?.response?.status || 500,
      });
    }
  },
);

//trashed products
export const trashedProducts = createAsyncThunk(
  "seller/trashedProducts",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.trashProducts();
      // console.log("Trash Product Response:", response);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch trashed products",
      );
    }
  },
);

//restore products
export const restoreProducts = createAsyncThunk(
  "seller/restoreProducts",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await sellerService.restoreProducts(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to restore products",
      );
    }
  },
);

//calculate price
export const calculatePrice = createAsyncThunk(
  "seller/calculatePrice",
  async (data, thunkAPI) => {
    try {
      const response = await sellerService.calculatePrice(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to calculate product price",
      );
    }
  },
);

//get dashboard data
export const fetchDashboardData = createAsyncThunk(
  "seller/fetchDashboardData",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getDashBoardData();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch dashboard data",
      );
    }
  },
);

//metal price trade
export const metalPriceTrade = createAsyncThunk(
  "seller/metalPriceTrade",
  async (data, thunkAPI) => {
    try {
      const response = await sellerService.metalPrice(data);
      // console.log("Metal Price Response in Redux:", response.data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch metal price data",
      );
    }
  },
);

//get metal code
export const fetchMetalCode = createAsyncThunk(
  "seller/fetchMetalCode",
  async (data, thunkAPI) => {
    try {
      const response = await sellerService.getMetalCode(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch metal code",
      );
    }
  },
);

//get stock list
export const fetchStockList = createAsyncThunk(
  "seller/fetchStockList",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getStockList();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch stock list",
      );
    }
  },
);

//update stock
export const updateStock = createAsyncThunk(
  "seller/updateStock",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await sellerService.updateStock(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update stock",
      );
    }
  },
);

export const fetchBids = createAsyncThunk(
  "seller/fetchBids",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getBids();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to fetch bids");
    }
  },
);

export const updateBidStatus = createAsyncThunk(
  "seller/updateBidStatus",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await sellerService.updateBidStatus(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update bid status",
      );
    }
  },
);

export const fetchOrders = createAsyncThunk(
  "seller/fetchOrders",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getOrders();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch orders",
      );
    }
  },
);

export const fetchOrderDetails = createAsyncThunk(
  "seller/fetchOrderDetails",
  async (id, thunkAPI) => {
    try {
      const response = await sellerService.getOrderDetails(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch order details",
      );
    }
  },
);

export const updateOrderStatus = createAsyncThunk(
  "seller/updateOrderStatus",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await sellerService.updateOrderStatus(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update order status",
      );
    }
  },
);

export const fetchShippingPartners = createAsyncThunk(
  "seller/fetchShippingPartners",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getShippingPartners();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch shipping partners",
      );
    }
  },
);

export const updateShippingPartner = createAsyncThunk(
  "seller/updatingShippingPartner",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await sellerService.updateShippingPartner(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update shippinh partner",
      );
    }
  },
);

export const updateTrackingNumber = createAsyncThunk(
  "seller/updateTrackingNumber",
  async (data, thunkAPI) => {
    try {
      const response = await sellerService.updateTrackingNumber(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update tracking number",
      );
    }
  },
);

export const fetchInvoiceList = createAsyncThunk(
  "seller/fetchInvoiceList",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getInvoiceList();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch Invoice List",
      );
    }
  },
);

export const fetchInvoiceDetails = createAsyncThunk(
  "seller/fetchInvoiceDetails",
  async (id, thunkAPI) => {
    try {
      const response = await sellerService.getInvoiceDetails(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch Invoice Details",
      );
    }
  },
);

export const fetchCategories = createAsyncThunk(
  "seller/fetchCategories",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getCategories();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch categories",
      );
    }
  },
);

export const fetchSubcategories = createAsyncThunk(
  "seller/fetchSubcategories",
  async (id, thunkAPI) => {
    try {
      const response = await sellerService.getSubcategories(id);
      // console.log("Sub category response:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch Subcategories",
      );
    }
  },
);

export const fetchSpecifications = createAsyncThunk(
  "seller/fetchSpecifications",
  async (id, thunkAPI) => {
    try {
      const response = await sellerService.getSpecifications(id);
      // console.log("Specification response:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch Subcategories",
      );
    }
  },
);

export const storeReverseBid = createAsyncThunk(
  "seller/storeReverseBid",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await sellerService.storeReverseBid(id, data);
      // console.log("Store Reverse Bid Response:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to store reverse bid",
      );
    }
  },
);

export const fetchReverseBids = createAsyncThunk(
  "seller/fetchReverseBids",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getReverseBids();

      // console.log("Reverse Bids Response:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch reverse bids",
      );
    }
  },
);

export const fetchReverseBidOrders = createAsyncThunk(
  "seller/fetchReverseBidOrders",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getReverseBidOrders();
      // console.log("Reverse Bid Orders Response:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch reverse bid orders",
      );
    }
  },
);

// Upload Certificates
export const uploadCertificates = createAsyncThunk(
  "seller/uploadCertificates",
  async (formData, thunkAPI) => {
    try {
      const response = await sellerService.uploadCertificates(formData); // already unwrapped
      // console.log("Upload Certificates Response:", response); // no .data
      return response; // just return this
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to upload certificate",
      });
    }
  },
);

// Get Certificates List
export const fetchCertificatesList = createAsyncThunk(
  "seller/fetchUserCertificateList",
  async (_, thunkAPI) => {
    try {
      const response = await getCertificatesList();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch certificate list");
    }
  },
);

// Get Payment Methods
export const fetchPaymentMethods = createAsyncThunk(
  "seller/fetchPaymentMethods",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getPaymentMethods();
      // console.log('res data of payment:',response)
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch payment methods",
      );
    }
  },
);

// Get Account Status
export const fetchAccountStatus = createAsyncThunk(
  "seller/fetchAccountStatus",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getAccountStatus();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch account status",
      );
    }
  },
);

// Generate Ai Description
export const generateAiDescription = createAsyncThunk(
  "seller/generateDescription",
  async (data, thunkAPI) => {
    try {
      console.log("AI THUNK PAYLOAD:", data);

      const response = await sellerService.generateDescription(data);
      console.log("AI API response:", response);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to generate description",
      );
    }
  },
);

// Generate Ai Faqs
export const generateAiFaqs = createAsyncThunk(
  "seller/generateFaqs",
  async (data, thunkAPI) => {
    try {
      const response = await sellerService.generateFaqs(data);
      console.log("AI API response:", response);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to generate faqs",
      );
    }
  },
);

// Generate Video Upload URL
export const generateVideoUrl = createAsyncThunk(
  "seller/generateVideoUrl",
  async (id, thunkAPI) => {
    try {
      const response = await sellerService.generateVideoUrl(id);
      console.log("Video URL response:", response);
      return {
        upload_url: response.upload_url,
        expires_in_hours: response.expires_in_hours,
        generated_at: Date.now(),
        productId: id, // IMPORTANT
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to generate video upload URL",
      );
    }
  },
);

// Received Offers
export const getReceivedOffers = createAsyncThunk(
  "seller/getReceivedOffers",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.getReceivedOffers();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch received offers",
      );
    }
  },
);

// Respond to Counter Offer
export const respondCounterOffer = createAsyncThunk(
  "seller/respondCounterOffer",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await sellerService.respondCounterOffer(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to respond to counter offer",
      );
    }
  },
);

// Received Offers Detail
export const fetchReceivedOffersDetail = createAsyncThunk(
  "seller/fetchReceivedOffersDetail",
  async (id, thunkAPI) => {
    try {
      const response = await sellerService.receivedOffersDetail(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch offers detail",
      );
    }
  },
);

// Out of range list
export const fetchOutOfRange = createAsyncThunk(
  "buyer/fetchOutOfRange",
  async (_, { rejectWithValue }) => {
    try {
      const response = await sellerService.getOutOfRange();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

// Approve Request
export const approveRequest = createAsyncThunk(
  "buyer/approveRequest",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      console.log("APPROVE REQUEST ID:", id);
      console.log("APPROVE REQUEST BODY:", data);

      const response = await sellerService.approveRequest(id, data);
      console.log("Approved Response:", response);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

// Reject Request
export const rejectRequest = createAsyncThunk(
  "buyer/rejectRequest",
  async (id, { rejectWithValue }) => {
    try {
      const response = await sellerService.rejectRequest(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

// Fetch Onboarding List
export const fetchOnboardingList = createAsyncThunk(
  "seller/fetchOnboardingList",
  async (_, thunkAPI) => {
    try {
      const response = await sellerService.onboardingList();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch onboarding list",
      );
    }
  },
);

// Submit Onboarding Data
export const submitOnboardingData = createAsyncThunk(
  "seller/submitOnboardingData",
  async (data, thunkAPI) => {
    try {
      const response = await sellerService.onboardingSubmit(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to submit onboarding data",
      );
    }
  },
);

// Initial State
const initialState = {
  product: {
    list: [],
    detail: null,
    loading: false,
    error: null,
    calculatedPrice: null,
  },
  trashedProducts: {
    list: [],
    loading: false,
    error: null,
  },
  orders: {
    list: [],
    detail: null,
    loading: false,
    error: null,
  },
  dashboard: {
    data: null,
    loading: false,
    error: null,
  },
  metalPrice: {
    data: [],
    message: "",
    loading: false,
    error: null,
  },
  metalCode: {
    data: "",
    loading: false,
    error: null,
  },
  stock: {
    list: [],
    loading: false,
    error: null,
  },
  bids: {
    list: [],
    loading: false,
    error: null,
  },
  shipping: {
    partners: [],
    loading: false,
    error: null,
  },
  invoice: {
    list: [],
    detail: null,
    loading: false,
    error: null,
  },
  categories: {
    list: [],
    loading: false,
    error: null,
  },
  subCategories: {
    list: [],
    loading: false,
    error: null,
  },
  specifications: {
    list: [],
    loading: false,
    error: null,
  },

  reverseBids: {
    list: [],
    loading: false,
    error: null,
  },

  certificates: {
    list: [],
    loading: false,
    error: null,
    success: null,
  },
  paymentMethods: {
    data: {},
    loading: false,
    error: null,
    success: null,
  },
  stripeConnecting: false,
  accountStatus: {
    data: null,
    loading: false,
    error: null,
  },

  ai: {
    generatingDescription: false,
    generatingFaqs: false,
    error: null,
    description: "",
    faqs: [],
  },
  videoUrl: {
    url: "",
    expires_in_hours: 0,
    loading: false,
    error: null,
    generated_at: null,
    productId: null,
  },
  respondCounterOffer: {
    data: null,
    loading: false,
    error: null,
  },
  receivedOffers: {
    data: [],
    loading: false,
    error: null,
  },
  receivedOffersDetail: {
    data: [],
    loading: false,
    error: null,
  },
  outOfRange: {
    data: null,
    loading: false,
    error: null,
  },
  approveRequest: {
    loading: false,
    success: false,
    error: null,
  },
  rejectRequest: {
    loading: false,
    success: false,
    error: null,
  },
  onboarding: {
    list: [],
    loading: false,
    error: null,
  },
};

const sellerSlice = createSlice({
  name: "seller",
  initialState,
  reducers: {
    clearProductDetail(state) {
      state.product.detail = null;
    },
    clearMetalPrice: (state) => {
      state.metalPrice.data = [];
      state.metalPrice.message = "";
      state.metalPrice.error = null;
    },
    clearMetalCode: (state) => {
      state.metalCode.data = "";
      state.metalCode.loading = false;
      state.metalCode.error = null;
    },
    clearReverseBids: (state) => {
      state.reverseBids.list = [];
      state.reverseBids.loading = false;
      state.reverseBids.error = null;
    },
    clearCertificates: (state) => {
      state.certificates.list = [];
      state.certificates.loading = null;
      state.certificates.error = null;
      state.certificates.success = null;
    },
    clearPaymentMethods: (state) => {
      state.paymentMethods.data = {};
      state.paymentMethods.loading = false;
      state.paymentMethods.error = null;
      state.paymentMethods.success = null;
    },
    clearAiState: (state) => {
      state.ai.generatingDescription = false;
      state.ai.generatingFaqs = false;
      state.ai.error = null;
      state.ai.description = "";
      state.ai.faqs = [];
    },
    clearVideoUrl: (state) => {
      state.videoUrl.url = "";
      state.videoUrl.loading = false;
      state.videoUrl.error = null;
    },
    clearRespondCounterOfferState: (state) => {
      state.respondCounterOffer.data = null;
      state.respondCounterOffer.loading = false;
      state.respondCounterOffer.error = null;
    },
    clearReceivedOffers: (state) => {
      state.receivedOffers.data = [];
      state.receivedOffers.loading = false;
      state.receivedOffers.error = null;
    },
    clearReceivedOffersDetail: (state) => {
      state.receivedOffersDetail.data = [];
      state.receivedOffersDetail.loading = false;
      state.receivedOffersDetail.error = null;
    },
    clearAccountStatus: (state) => {
      state.accountStatus.data = null;
      state.accountStatus.loading = false;
      state.accountStatus.error = null;
    },
    clearOnboardingState: (state) => {
      state.onboarding.list = [];
      state.onboarding.loading = false;
      state.onboarding.error = null;
    },
    resetApproveRequest(state) {
      state.approveRequest = {
        loading: false,
        success: false,
        error: null,
      };
    },
    resetRejectRequest(state) {
      state.rejectRequest = {
        loading: false,
        success: false,
        error: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllProducts.pending, (state) => {
        state.product.loading = true;
        state.product.error = null;
      })
      .addCase(fetchAllProducts.fulfilled, (state, action) => {
        state.product.loading = false;
        state.product.list = action.payload;
      })
      .addCase(fetchAllProducts.rejected, (state, action) => {
        state.product.loading = false;
        state.product.error = action.payload;
      })

      .addCase(fetchProductDetails.pending, (state) => {
        state.product.loading = true;
        state.product.error = null;
      })
      .addCase(fetchProductDetails.fulfilled, (state, action) => {
        state.product.loading = false;
        state.product.detail = action.payload;
      })
      .addCase(fetchProductDetails.rejected, (state, action) => {
        state.product.loading = false;
        state.product.error = action.payload;
      })

      // For trashed products
      .addCase(trashedProducts.pending, (state) => {
        state.trashedProducts.loading = true;
        state.trashedProducts.error = null;
      })
      .addCase(trashedProducts.fulfilled, (state, action) => {
        state.trashedProducts.loading = false;
        state.trashedProducts.list = action.payload;
      })
      .addCase(trashedProducts.rejected, (state, action) => {
        state.trashedProducts.loading = false;
        state.trashedProducts.error = action.payload;
      })

      // For restore product (remove from trashedProducts.list)
      .addCase(restoreProducts.fulfilled, (state, action) => {
        state.trashedProducts.list = state.trashedProducts.list.filter(
          (p) => p.id !== action.meta.arg.id,
        );
      })

      // For calculate price
      .addCase(calculatePrice.fulfilled, (state, action) => {
        state.product.calculatedPrice = action.payload;
      })

      .addCase(fetchOrders.pending, (state) => {
        state.orders.loading = true;
        state.orders.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.orders.loading = false;
        state.orders.list = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.orders.loading = false;
        state.orders.error = action.payload;
      })

      .addCase(fetchOrderDetails.pending, (state) => {
        state.orders.loading = true;
        state.orders.error = null;
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.orders.loading = false;
        state.orders.detail = action.payload;
      })
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.orders.loading = false;
        state.orders.error = action.payload;
      })

      .addCase(updateOrderStatus.pending, (state) => {
        state.orders.loading = true;
        state.orders.error = null;
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.orders.loading = false;
        // Optionally update order detail or list if needed
      })
      .addCase(updateOrderStatus.rejected, (state, action) => {
        state.orders.loading = false;
        state.orders.error = action.payload;
      })

      .addCase(fetchDashboardData.pending, (state) => {
        state.dashboard.loading = true;
        state.dashboard.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.dashboard.loading = false;
        state.dashboard.data = action.payload;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.dashboard.loading = false;
        state.dashboard.error = action.payload;
      })

      .addCase(metalPriceTrade.pending, (state) => {
        state.metalPrice.loading = true;
        state.metalPrice.error = null;
      })
      .addCase(metalPriceTrade.fulfilled, (state, action) => {
        state.metalPrice.loading = false;
        state.metalPrice.data = action.payload.data || [];
        state.metalPrice.message = action.payload.message || "";
      })

      .addCase(metalPriceTrade.rejected, (state, action) => {
        state.metalPrice.loading = false;
        state.metalPrice.error = action.payload;
      })

      .addCase(fetchMetalCode.pending, (state) => {
        state.metalCode.loading = true;
        state.metalCode.error = null;
      })

      .addCase(fetchMetalCode.fulfilled, (state, action) => {
        state.metalCode.loading = false;
        state.metalCode.data = action.payload;
      })

      .addCase(fetchMetalCode.rejected, (state, action) => {
        state.metalCode.loading = false;
        state.metalCode.error = action.payload;
      })

      .addCase(fetchStockList.pending, (state) => {
        state.stock.loading = true;
        state.stock.error = null;
      })
      .addCase(fetchStockList.fulfilled, (state, action) => {
        state.stock.loading = false;
        state.stock.list = action.payload;
      })
      .addCase(fetchStockList.rejected, (state, action) => {
        state.stock.loading = false;
        state.stock.error = action.payload;
      })

      .addCase(fetchBids.pending, (state) => {
        state.bids.loading = true;
        state.bids.error = null;
      })
      .addCase(fetchBids.fulfilled, (state, action) => {
        state.bids.loading = false;
        state.bids.list = action.payload;
      })
      .addCase(fetchBids.rejected, (state, action) => {
        state.bids.loading = false;
        state.bids.error = action.payload;
      })

      .addCase(fetchInvoiceList.pending, (state) => {
        state.invoice.loading = true;
        state.invoice.error = null;
      })
      .addCase(fetchInvoiceList.fulfilled, (state, action) => {
        state.invoice.loading = false;
        state.invoice.list = action.payload;
      })
      .addCase(fetchInvoiceList.rejected, (state, action) => {
        state.invoice.loading = false;
        state.invoice.error = action.payload;
      })

      .addCase(fetchInvoiceDetails.pending, (state) => {
        state.invoice.loading = true;
        state.invoice.error = null;
      })
      .addCase(fetchInvoiceDetails.fulfilled, (state, action) => {
        state.invoice.loading = false;
        state.invoice.detail = action.payload;
      })
      .addCase(fetchInvoiceDetails.rejected, (state, action) => {
        state.invoice.loading = false;
        state.invoice.error = action.payload;
      })

      .addCase(fetchShippingPartners.pending, (state) => {
        state.shipping.loading = true;
        state.shipping.error = null;
      })
      .addCase(fetchShippingPartners.fulfilled, (state, action) => {
        state.shipping.loading = false;
        state.shipping.partners = action.payload;
      })
      .addCase(fetchShippingPartners.rejected, (state, action) => {
        state.shipping.loading = false;
        state.shipping.error = action.payload;
      })

      .addCase(updateShippingPartner.pending, (state) => {
        state.shipping.loading = true;
        state.shipping.error = null;
      })
      .addCase(updateShippingPartner.fulfilled, (state, action) => {
        state.shipping.loading = false;
        // Optionally update shipping.partner(s) if needed
      })
      .addCase(updateShippingPartner.rejected, (state, action) => {
        state.shipping.loading = false;
        state.shipping.error = action.payload;
      })

      .addCase(updateTrackingNumber.pending, (state) => {
        state.orders.loading = true;
        state.orders.error = null;
      })
      .addCase(updateTrackingNumber.fulfilled, (state, action) => {
        state.orders.loading = false;
        // Optionally update order detail or list if needed
      })
      .addCase(updateTrackingNumber.rejected, (state, action) => {
        state.orders.loading = false;
        state.orders.error = action.payload;
      })
      .addCase(fetchCategories.pending, (state) => {
        state.categories.loading = true;
        state.categories.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categories.loading = false;
        state.categories.list = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.categories.loading = false;
        state.categories.error = action.payload;
      })
      .addCase(fetchSubcategories.pending, (state) => {
        state.subCategories.loading = true;
        state.subCategories.error = null;
      })
      .addCase(fetchSubcategories.fulfilled, (state, action) => {
        state.subCategories.loading = false;
        state.subCategories.list = action.payload;
      })
      .addCase(fetchSubcategories.rejected, (state, action) => {
        state.subCategories.loading = false;
        state.subCategories.error = action.payload;
      })
      .addCase(fetchSpecifications.pending, (state) => {
        state.specifications.loading = true;
        state.specifications.error = null;
      })
      .addCase(fetchSpecifications.fulfilled, (state, action) => {
        state.specifications.loading = false;
        state.specifications.list = action.payload;
      })
      .addCase(fetchSpecifications.rejected, (state, action) => {
        state.specifications.loading = false;
        state.specifications.error = action.payload;
      })

      .addCase(storeReverseBid.pending, (state) => {
        state.reverseBids.loading = true;
        state.reverseBids.error = null;
      })
      .addCase(storeReverseBid.fulfilled, (state, action) => {
        state.reverseBids.loading = false;
        // Optionally update reverse bids list if needed
      })
      .addCase(storeReverseBid.rejected, (state, action) => {
        state.reverseBids.loading = false;
        state.reverseBids.error = action.payload;
      })
      .addCase(fetchReverseBids.pending, (state) => {
        state.reverseBids.loading = true;
        state.reverseBids.error = null;
      })
      .addCase(fetchReverseBids.fulfilled, (state, action) => {
        state.reverseBids.loading = false;
        state.reverseBids.list = action.payload;
      })
      .addCase(fetchReverseBids.rejected, (state, action) => {
        state.reverseBids.loading = false;
        state.reverseBids.error = action.payload;
      })
      .addCase(fetchReverseBidOrders.pending, (state) => {
        state.reverseBids.loading = true;
        state.reverseBids.error = null;
      })
      .addCase(fetchReverseBidOrders.fulfilled, (state, action) => {
        state.reverseBids.loading = false;
        state.reverseBids.list = action.payload;
      })
      .addCase(fetchReverseBidOrders.rejected, (state, action) => {
        state.reverseBids.loading = false;
        state.reverseBids.error = action.payload;
      })

      // Upload Certificates
      .addCase(uploadCertificates.pending, (state) => {
        state.certificates.loading = true;
        state.certificates.error = null;
        state.certificates.success = null;
      })

      .addCase(uploadCertificates.fulfilled, (state, action) => {
        state.certificates.loading = false;
        state.certificates.success = action.payload;
      })
      .addCase(uploadCertificates.rejected, (state, action) => {
        state.certificates.loading = false;
        state.certificates.error = action.payload;
        state.certificates.success = null;
      })

      // Fetch Certificates List
      .addCase(fetchCertificatesList.pending, (state) => {
        state.certificates.loading = true;
        state.certificates.error = null;
      })
      .addCase(fetchCertificatesList.fulfilled, (state, action) => {
        state.certificates.loading = false;
        state.certificates.list = action.payload || [];
      })
      .addCase(fetchCertificatesList.rejected, (state, action) => {
        state.certificates.loading = false;
        state.certificates.error = action.payload;
      })

      //Fetch Payment Methods
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.stripeConnecting = true;
        state.paymentMethods.loading = true;
        state.paymentMethods.error = null;
      })
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.stripeConnecting = false;
        state.paymentMethods.loading = false;
        state.paymentMethods.data = action.payload || {};
      })
      .addCase(fetchPaymentMethods.rejected, (state, action) => {
        state.stripeConnecting = false;
        state.paymentMethods.loading = false;
        state.paymentMethods.error = action.payload;
      })

      // Fetch Account Status
      .addCase(fetchAccountStatus.pending, (state) => {
        state.accountStatus.loading = true;
        state.accountStatus.error = null;
      })
      .addCase(fetchAccountStatus.fulfilled, (state, action) => {
        state.accountStatus.loading = false;
        state.accountStatus.data = action.payload;
      })
      .addCase(fetchAccountStatus.rejected, (state, action) => {
        state.accountStatus.loading = false;
        state.accountStatus.error = action.payload;
      })

      // Generate Ai Description
      .addCase(generateAiDescription.pending, (state) => {
        state.ai.generatingDescription = true;
        state.ai.error = null;
        state.ai.description = "";
      })
      .addCase(generateAiDescription.fulfilled, (state, action) => {
        console.log("🧠 AI FULL PAYLOAD:", action.payload);
        state.ai.generatingDescription = false;
        state.ai.description = action.payload.description || "";
      })
      .addCase(generateAiDescription.rejected, (state, action) => {
        state.ai.generatingDescription = false;
        state.ai.error = action.payload;
        state.ai.description = "";
      })

      // Generate Ai Faqs
      .addCase(generateAiFaqs.pending, (state) => {
        state.ai.generatingFaqs = true;
        state.ai.error = null;
        state.ai.faqs = [];
      })
      .addCase(generateAiFaqs.fulfilled, (state, action) => {
        state.ai.generatingFaqs = false;
        state.ai.faqs = (action.payload.faqs || []).map((f) => ({
          question: f.q,
          answer: f.a,
        }));
      })
      .addCase(generateAiFaqs.rejected, (state, action) => {
        state.ai.generatingFaqs = false;
        state.ai.error = action.payload;
        state.ai.faqs = [];
      })

      // Generate Video Upload URL
      .addCase(generateVideoUrl.pending, (state) => {
        state.videoUrl.loading = true;
        state.videoUrl.error = null;
        state.videoUrl.url = "";
      })
      .addCase(generateVideoUrl.fulfilled, (state, action) => {
        const { upload_url, expires_in_hours, generated_at, productId } =
          action.payload;

        state.videoUrl.loading = false;
        state.videoUrl.url = upload_url || "";
        state.videoUrl.expires_in_hours = expires_in_hours;
        state.videoUrl.generated_at = generated_at;

        if (!state.videoUrl.cooldowns) state.videoUrl.cooldowns = {};

        state.videoUrl.cooldowns[productId] = {
          expires_at: generated_at + expires_in_hours * 3600000,
          generated_at,
        };

        // Clear errors
        state.videoUrl.error = null;
      })
      .addCase(generateVideoUrl.rejected, (state, action) => {
        state.videoUrl.loading = false;
        state.videoUrl.error = action.payload;
        state.videoUrl.url = "";
      })

      // Get Received Offers
      .addCase(getReceivedOffers.pending, (state) => {
        state.receivedOffers.loading = true;
        state.receivedOffers.error = null;
      })
      .addCase(getReceivedOffers.fulfilled, (state, action) => {
        state.receivedOffers.loading = false;
        state.receivedOffers.data = action.payload || [];
      })
      .addCase(getReceivedOffers.rejected, (state, action) => {
        state.receivedOffers.loading = false;
        state.receivedOffers.error = action.payload;
      })

      // Respond to Counter Offer
      .addCase(respondCounterOffer.pending, (state) => {
        state.respondCounterOffer.loading = true;
        state.respondCounterOffer.error = null;
      })
      .addCase(respondCounterOffer.fulfilled, (state, action) => {
        state.respondCounterOffer.loading = false;
        state.respondCounterOffer.data = action.payload;
      })
      .addCase(respondCounterOffer.rejected, (state, action) => {
        state.respondCounterOffer.loading = false;
        state.respondCounterOffer.error = action.payload;
      })

      // Received Offers Detail
      .addCase(fetchReceivedOffersDetail.pending, (state) => {
        state.receivedOffersDetail.loading = true;
        state.receivedOffersDetail.error = null;
      })
      .addCase(fetchReceivedOffersDetail.fulfilled, (state, action) => {
        state.receivedOffersDetail.loading = false;
        state.receivedOffersDetail.data = action.payload;
      })
      .addCase(fetchReceivedOffersDetail.rejected, (state, action) => {
        state.receivedOffersDetail.loading = false;
        state.receivedOffersDetail.error = action.payload;
      })

      // Fetch Out Of Range
      .addCase(fetchOutOfRange.pending, (state) => {
        state.outOfRange.loading = true;
        state.outOfRange.error = null;
      })
      .addCase(fetchOutOfRange.fulfilled, (state, action) => {
        state.outOfRange.loading = false;
        state.outOfRange.data = action.payload;
      })
      .addCase(fetchOutOfRange.rejected, (state, action) => {
        state.outOfRange.loading = false;
        state.outOfRange.error = action.payload;
      })

      // Approve Request
      .addCase(approveRequest.pending, (state) => {
        state.approveRequest.loading = true;
        state.approveRequest.error = null;
        state.approveRequest.success = false;
      })
      .addCase(approveRequest.fulfilled, (state) => {
        state.approveRequest.loading = false;
        state.approveRequest.success = true;
      })
      .addCase(approveRequest.rejected, (state, action) => {
        state.approveRequest.loading = false;
        state.approveRequest.error = action.payload;
      })

      // Reject Request
      .addCase(rejectRequest.pending, (state) => {
        state.rejectRequest.loading = true;
        state.rejectRequest.error = null;
        state.rejectRequest.success = false;
      })
      .addCase(rejectRequest.fulfilled, (state) => {
        state.rejectRequest.loading = false;
        state.rejectRequest.success = true;
      })
      .addCase(rejectRequest.rejected, (state, action) => {
        state.rejectRequest.loading = false;
        state.rejectRequest.error = action.payload;
      })

      // Fetch Onboarding List
      .addCase(fetchOnboardingList.pending, (state) => {
        state.onboarding.loading = true;
        state.onboarding.error = null;
      })
      .addCase(fetchOnboardingList.fulfilled, (state, action) => {
        state.onboarding.loading = false;
        state.onboarding.list = action.payload;
      })
      .addCase(fetchOnboardingList.rejected, (state, action) => {
        state.onboarding.loading = false;
        state.onboarding.error = action.payload;
      })

      // Submit Onboarding Data
      .addCase(submitOnboardingData.pending, (state) => {
        state.onboarding.loading = true;
        state.onboarding.error = null;
      })
      .addCase(submitOnboardingData.fulfilled, (state, action) => {
        state.onboarding.loading = false;
        // Optionally handle response if needed
      })
      .addCase(submitOnboardingData.rejected, (state, action) => {
        state.onboarding.loading = false;
        state.onboarding.error = action.payload;
      });
  },
});

export const {
  clearProductDetail,
  clearMetalPrice,
  clearAiState,
  clearVideoUrl,
  clearMetalCode,
  clearReverseBids,
  clearCertificates,
  clearPaymentMethods,
  clearRespondCounterOfferState,
  clearReceivedOffers,
  clearReceivedOffersDetail,
  clearOnboardingState,
} = sellerSlice.actions;
export default sellerSlice.reducer;
